module.exports = __webpack_public_path__ + "img/chat_ai_logo.77674115.png";